import { render, staticRenderFns } from "./QSummitStepBackgroundBottomLeft.vue?vue&type=template&id=fb36dc2c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports